import BaseApiService from 'src/api/services/baseApiService';
import {
    SearchByPassengerRequest,
    SearchByTicketRequest,
    SearchByPassengerResult,
    SearchByTicketResult,
    SearchByDocumentRequest,
    SearchByDocumentResult
} from '../contracts';

class DataSearchApiService extends BaseApiService {
    searchByTicket = async (request: SearchByTicketRequest) => {
        return await this.post<SearchByTicketResult, SearchByTicketRequest>('search/by-ticket', request);
    };

    exportSearchByTicketResult = async (request: SearchByTicketRequest) => {
        return await this.post<Blob, SearchByTicketRequest>('search/by-ticket/download', request, {
            responseType: 'blob'
        });
    };

    searchByPassenger = async (request: SearchByPassengerRequest) => {
        return await this.post<SearchByPassengerResult, SearchByPassengerRequest>('search/by-passenger', request);
    };

    exportSearchByPassengerResult = async (request: SearchByPassengerRequest) => {
        return await this.post<Blob, SearchByPassengerRequest>('search/by-passenger/download', request, {
            responseType: 'blob'
        });
    };

    searchByDocument = async (request: SearchByDocumentRequest) => {
        return await this.post<SearchByDocumentResult, SearchByDocumentRequest>('search/by-document', request);
    };

    exportSearchByDocumentResult = async (request: SearchByDocumentRequest) => {
        return await this.post<Blob, SearchByDocumentRequest>('search/by-document/download', request, {
            responseType: 'blob'
        });
    };
}

export default new DataSearchApiService();
